<mat-form-field appearance="outline">
	<mat-label>{{ data!.label }}</mat-label>
	<input matInput type="text" [(ngModel)]="data!.value" [disabled]="data!.disabled" (change)="onModelChange()"
		[attr.maxLength]="data?.maxLength || null"
		[matTooltip]="data?.maxLength ? 'Maximum ' + data.maxLength + ' characters allowed.' : ''">
</mat-form-field>